'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Heading } from '@petsmart-ui/sparky';
import { type ReactElement, useState } from 'react';
import { RemoveCardModal } from '../RemoveCardModal';
import { AddPaymentForm } from './AddPaymentForm';
import { EditPaymentForm } from './EditPaymentForm';
import type { PaymentFormProps } from './types';
import './PaymentForm.scss';
export function PaymentForm(t0) {
  const $ = _c(32);
  const {
    title: t1,
    subtitle: t2,
    isDefaultCheckDisabled,
    isDefaultCheckChecked,
    setBillingAddressAsDefaultShippingInMarketOnly,
    editPaymentData,
    onCloseForm,
    onSuccess,
    onError,
    defaultAddressId,
    onEditSubmit,
    onAddressValidationApiError,
    disableUntilDirty,
    addAddressIconSize,
    onRemoveCardClick,
    onExperianModalVisibilityChange: t3,
    onClearError,
    hideCancelCta,
    submitCtaText
  } = t0;
  const title = t1 === undefined ? "Payments" : t1;
  const subtitle = t2 === undefined ? "Add credit or debit card" : t2;
  const onExperianModalVisibilityChange = t3 === undefined ? _temp : t3;
  const [openModal, setOpenModal] = useState(false);
  let t4;
  if ($[0] !== title) {
    t4 = title && <Heading tagName="h5" data-testid="payment-form-title">{title}</Heading>;
    $[0] = title;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== editPaymentData || $[3] !== subtitle) {
    t5 = subtitle && <Heading tagName="h6" size="body-lg-bold" data-testid="payment-form-subtitle" className={editPaymentData ? "payment-form__subtitle" : ""}>{editPaymentData ? "Edit card" : subtitle}</Heading>;
    $[2] = editPaymentData;
    $[3] = subtitle;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== addAddressIconSize || $[6] !== defaultAddressId || $[7] !== disableUntilDirty || $[8] !== editPaymentData || $[9] !== hideCancelCta || $[10] !== isDefaultCheckChecked || $[11] !== isDefaultCheckDisabled || $[12] !== onAddressValidationApiError || $[13] !== onClearError || $[14] !== onCloseForm || $[15] !== onEditSubmit || $[16] !== onError || $[17] !== onExperianModalVisibilityChange || $[18] !== onSuccess || $[19] !== setBillingAddressAsDefaultShippingInMarketOnly || $[20] !== submitCtaText) {
    t6 = editPaymentData ? <EditPaymentForm isDefaultCheckDisabled={isDefaultCheckDisabled || false} editPaymentData={editPaymentData} onCloseForm={onCloseForm} onSuccess={isDefault => onSuccess({
      isEdit: true,
      isDefault
    })} onError={onError} onClearError={onClearError} onSubmit={onEditSubmit} onAddressValidationApiError={onAddressValidationApiError} disableUntilDirty={disableUntilDirty} addAddressIconSize={addAddressIconSize} defaultAddressId={defaultAddressId} onExperianModalVisibilityChange={onExperianModalVisibilityChange} /> : <AddPaymentForm isDefaultCheckDisabled={isDefaultCheckDisabled || false} isDefaultCheckChecked={isDefaultCheckChecked || false} setBillingAddressAsDefaultShippingInMarketOnly={setBillingAddressAsDefaultShippingInMarketOnly || false} onCloseForm={onCloseForm} onSuccess={args => onSuccess({
      isEdit: false,
      isDefault: args?.isDefault,
      addressToLink: args?.addressToLink
    })} onError={onError} onClearError={onClearError} defaultAddressId={defaultAddressId} addAddressIconSize={addAddressIconSize} onExperianModalVisibilityChange={onExperianModalVisibilityChange} onAddressValidationApiError={onAddressValidationApiError} hideCancelCta={hideCancelCta} submitCtaText={submitCtaText} />;
    $[5] = addAddressIconSize;
    $[6] = defaultAddressId;
    $[7] = disableUntilDirty;
    $[8] = editPaymentData;
    $[9] = hideCancelCta;
    $[10] = isDefaultCheckChecked;
    $[11] = isDefaultCheckDisabled;
    $[12] = onAddressValidationApiError;
    $[13] = onClearError;
    $[14] = onCloseForm;
    $[15] = onEditSubmit;
    $[16] = onError;
    $[17] = onExperianModalVisibilityChange;
    $[18] = onSuccess;
    $[19] = setBillingAddressAsDefaultShippingInMarketOnly;
    $[20] = submitCtaText;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== editPaymentData || $[23] !== onCloseForm || $[24] !== onRemoveCardClick || $[25] !== openModal) {
    t7 = editPaymentData && <><div className="payment-form__remove-button" data-testid="payment-form-remove-button"><Button text="Remove card" variant="link" onClick={() => onRemoveCardClick ? onRemoveCardClick() : setOpenModal(true)} /></div><RemoveCardModal currentPayment={editPaymentData} modalOpen={openModal} modalClose={hideForm => {
        setOpenModal(false);
        if (hideForm) {
          onCloseForm();
        }
      }} /></>;
    $[22] = editPaymentData;
    $[23] = onCloseForm;
    $[24] = onRemoveCardClick;
    $[25] = openModal;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7) {
    t8 = <div className="payment-form" data-testid="payment-form">{t4}{t5}{t6}{t7}</div>;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
}
function _temp() {}